import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'

type RenderMarkdownProps = {
  content: string
}

// This component renders both Markdown and Raw HTML
const RenderMarkdown: React.FC<RenderMarkdownProps> = ({
  content,
}: RenderMarkdownProps) => {
  const currentYear = new Date().getFullYear()
  return (
    <div className="prose max-w-none [&_a]:text-tenant-primary-color">
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {content?.replace('{{currentYear}}', String(currentYear))}
      </ReactMarkdown>
    </div>
  )
}

export { RenderMarkdown }
